import { nsTerminal } from '@/app/i18n/namespaces';

const EVENT_TYPE = {
    AUTHORIZATION: { name: 'AUTHORIZATION', entity: 'event_type.AUTHORIZATION', namespace: nsTerminal, variant: 'green' },
    REMOTE_COLLECTION: { name: 'REMOTE_COLLECTION', entity: 'event_type.REMOTE_COLLECTION', namespace: nsTerminal, variant: 'light-green' },
    NOT_COMPLETED: { name: 'NOT_COMPLETED', entity: 'event_type.NOT_COMPLETED', namespace: nsTerminal, variant: 'red' },
    INTERRUPTED: { name: 'INTERRUPTED', entity: 'event_type.INTERRUPTED', namespace: nsTerminal, variant: 'red' },
    IN_PROGRESS: { name: 'IN_PROGRESS', entity: 'event_type.IN_PROGRESS', namespace: nsTerminal, variant: 'orange' }
};

export default EVENT_TYPE;